export const pricelist: { size: string; price: number }[] = [
    {
        size: '0 - 60',
        price: 2500,
    },
    {
        size: '60 - 80',
        price: 3000,
    },
    {
        size: '80 - 120',
        price: 3500,
    },
    {
        size: '120 - 150',
        price: 4000,
    },
]
